module.exports = __webpack_public_path__ + "img/radio-selected-dot.2d0042d2.svg";